import { Flex } from "antd";
import { useState } from "react";
import Filters from "../../components/Filters";
import MainMetrics from "../../components/MainMetrics";
import TablesWrapper from "../../components/TablesWrapper";
import usePeakHoursKpiTable from "../../hooks/usePeakHoursKpiTable";
import {
  PEAK_HOURS_METRICS,
  PEAK_HOURS_TABLE_COLUMNS,
} from "../../utils/constants";
import ChartsWrapper from "./ChartsWrapper";

export default function PeakHoursRefact() {
  const [selectedDateRange, setSelectedDateRange] = useState([null, null]);
  const [selectedPeriod, setSelectedPeriod] = useState([9, 19]);
  const [selectedZones, setSelectedZones] = useState(["all"]);
  const [selectedCollections, setSelectedCollections] = useState(["all"]);

  const { isLoading: loadingKpiTable, data: kpiTableData } =
    usePeakHoursKpiTable({
      start_month: selectedDateRange[0],
      end_month: selectedDateRange[1],
      zones: selectedZones,
      collections: selectedCollections,
      enable: !!selectedDateRange[0] && !!selectedDateRange[1],
    });

  return (
    <Flex
      style={{ width: "100%", margin: "0 auto" }}
      justify="center"
      align="center"
      vertical
      gap={"50px"}>
      <Filters
        filters={["data", "zonas", "colecoes"]}
        isMainDataLoading={loadingKpiTable}
        dateRange={true}
        selectedDateRange={selectedDateRange}
        setSelectedDateRange={setSelectedDateRange}
        selectedPeriod={selectedPeriod}
        setSelectedPeriod={setSelectedPeriod}
        selectedZones={selectedZones}
        setSelectedZones={setSelectedZones}
        selectedCollections={selectedCollections}
        setSelectedCollections={setSelectedCollections}
      />
      <MainMetrics
        data={kpiTableData?.kpidata}
        isLoading={loadingKpiTable}
        kpis={PEAK_HOURS_METRICS}
      />
      <ChartsWrapper
        selectedDateRange={selectedDateRange}
        selectedZones={selectedZones}
        selectedCollections={selectedCollections}
      />
      <TablesWrapper
        data={kpiTableData?.tabledata}
        isLoading={loadingKpiTable}
        columns={PEAK_HOURS_TABLE_COLUMNS}
        tablesPerRow={1}
        tablesName={[
          "Horários com fluxo acima da média",
          "Horários com fluxo abaixo da média",
        ]}
      />
    </Flex>
  );
}
